import {
  CapabilitiesMarketplaceResponseDataSchema,
  CapabilitiesResponseDataSchema,
  CapabilityResponseDataSchema,
} from "schema"
import z from "zod"
import { CapabilityCustomDialog } from "./CapabilityCustomDialog"

type Props<Mode extends "install" | "configure"> = {
  capability: Mode extends "install"
    ? z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>[number]
    : z.infer<typeof CapabilitiesResponseDataSchema>[number]
  mode: Mode
  onOpenChange: (open: boolean) => void
  onConfigure?: (capability: z.infer<typeof CapabilityResponseDataSchema>) => void
}

export function CapabilityMCPDialog<Mode extends "install" | "configure">({
  capability,
  mode,
  onOpenChange,
  onConfigure,
}: Props<Mode>) {
  return (
    <CapabilityCustomDialog
      capability={capability}
      mode={mode}
      onOpenChange={onOpenChange}
      onConfigure={onConfigure}
    />
  )
}
